import React, { Component } from "react";
import CitizenPerceptionComponent from "../components/CitizenPerceptionComponent";
import Landing from "../../landing/containers/LandingContainer";

import { sendService, answerOk } from "../../Services/service";

import Generic from "./../components/GenericComponent";
import Georreferenciacion from "./GeoreferencingContainer";

import Tag from "../components/Tag";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../Actions/Dashboard";

const filterModel = {
  comuna: [],
  ocupacion: [],
  nivelEducativo: [],
  estrato: [],
  edad: [],
  genero: [],
};

class CitizenPerceptionContainer extends Component {
  state = {
    form: {},
    filter: {
      comuna: [],
      ocupacion: [],
      nivelEducativo: [],
      estrato: [],
      edad: [],
      genero: [],
    },
    filterArray: [],
    datos: [],
    result: [],
  };

  handlerChangeForm = (variable, value) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [variable]: value,
        },
      },
      () => this.getData()
    );
  };

  getData = async () => {
    const value = {
      filter: { ...this.state.filter },
      clasification: this.state.form.percepcionCitizen,
    };
    let url = "/api/v1/percepcion/results";
    var res = await sendService(url, "POST", value);
    if (
      !answerOk(res, () => {
        this.props.actions.activePage("/");
        this.props.history.push("/");
      })
    )
      return;
    console.log(res.response)
    this.setState({
      datos: res.response.datos,
      result: res.response.results,
    });
  };

  getFilter = (filterArray) => {
    let filter = JSON.parse(JSON.stringify(filterModel));
    for (let i = 0; i < filterArray.length; i++) {
      filter[filterArray[i].name].push(filterArray[i].id);
    }
    return filter;
  };

  getFilterArray = (clickData, filterData) => {
    let filter = [...filterData];
    if (JSON.stringify(filter).includes(JSON.stringify(clickData))) {
      let resp = filter
        .filter((item) => {
          if (JSON.stringify(item) === JSON.stringify(clickData)) return false;
          return true;
        })
        .map((item) => item);
      return resp;
    }
    filter.push(clickData);
    return filter;
  };

  handlerChangeFilter = (variable, value) => {
    let filterArray = this.getFilterArray(
      { id: value, value, name: variable },
      this.state.filterArray
    );
    let filter = this.getFilter(filterArray);

    this.setState(
      {
        filter,
        filterArray,
      },
      () => this.getData()
    );
  };

  selectPerception = () => {
    switch (this.state.form.percepcionCitizen) {
      case "HURTOS":
      case "LÍNEA 123":
      case "VICTIMIZACIÓN":
      case "PERCEPCIÓN":
        return (
          <Generic
            title={this.state.form.percepcionCitizen}
            result={this.state.result}
          />
        );
      case "CALIFICACIÓN":
        return (
          <Generic
            isCalificacion={true}
            title={this.state.form.percepcionCitizen}
            result={this.state.result}
          />
        );
      case "GEOGRÁFICO":
        return (
          <Georreferenciacion
            datos={this.state.datos}
            result={this.state.result}
          />
        );
      default:
        return <> </>;
    }
  };

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <CitizenPerceptionComponent
          formChange={this.handlerChangeForm}
          filterChange={this.handlerChangeFilter}
          form={this.state.form}
        />
        <div className="filter">
          {this.state.filterArray.map((tag, index) => (
            <Tag
              dato={tag}
              key={`tag-key-percepcion-${index}`}
              onClose={this.handlerChangeFilter}
            />
          ))}
        </div>
        {this.selectPerception()}
      </Landing>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(CitizenPerceptionContainer);
